import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import shallowCompare from 'react-addons-shallow-compare';
import cx from 'classnames';
import $ from 'jquery';
import { diagnosticTabHasTask } from '../utils/index';
import { getTabsToRender, tabLabel } from '../../../../common/tasks';

export const getDefaultTab = site =>
  getTabsToRender(site).find(t => diagnosticTabHasTask(t, site)) || 'RAT';

const tabClassName = (tab, current) =>
  cx('item', {
    active: current === tab,
  });

const DiagnosticTab = ({ tab, current, tasks, hasErrors, onChange }) => {
  const onClick = evt => {
    evt.preventDefault();
    onChange(tab);

    return false;
  };

  const hasTask = diagnosticTabHasTask(tab, tasks);

  const statusClassName = cx('icon marginLeft10', {
    'check circle outline': hasTask,
    radio: !hasTask,
    red: hasErrors,
  });

  return (
    <a className={tabClassName(tab, current)} onClick={onClick}>
      {tabLabel(tab)}
      <i className={statusClassName} />
    </a>
  );
};

DiagnosticTab.propTypes = {
  tab: PropTypes.string.isRequired,
  current: PropTypes.string.isRequired,
  tasks: PropTypes.object.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

class DiagnosticTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 140,
    };

    this._onTabChange = this._onTabChange.bind(this);
    this._setChildren = this._setChildren.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  _onTabChange(value) {
    const height = $(this._children).height();

    this.setState({
      height,
    });

    this.props.onChange(value);
  }

  _setChildren(ref) {
    this._children = ref;
  }

  _renderContent() {
    const { children, isFetching, currentTab } = this.props;
    const { height } = this.state;

    if (isFetching) {
      return (
        <div
          className="ui active bottom attached tab segment"
          style={{ minHeight: `${height}px` }}
        >
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Chargement du contenu</div>
          </div>
        </div>
      );
    }

    return (
      <div
        ref={this._setChildren}
        className="ui active bottom attached tab segment"
      >
        {children(currentTab)}
      </div>
    );
  }

  render() {
    const { site, currentTab, errors } = this.props;

    return (
      <div>
        <h3 className="ui header">Diagnostic</h3>
        <div className="ui top attached tabular menu">
          {getTabsToRender(site).map(t => (
            <DiagnosticTab
              key={t}
              tab={t}
              current={currentTab}
              tasks={site}
              hasErrors={(errors.get(t) && errors.get(t).length > 0) || false}
              onChange={this._onTabChange}
            />
          ))}
        </div>
        {this._renderContent()}
      </div>
    );
  }
}

DiagnosticTabs.propTypes = {
  currentTab: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  errors: ImmutablePropTypes.map.isRequired,
  site: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DiagnosticTabs;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/DiagnosticTabs.js